export default __webpack_public_path__ + "static/media/q2_03.07a79455.png";